export default __webpack_public_path__ + "static/media/token.4379775c.png";